<template>
    <div :class="avatarClass">
        <template v-if="ancillaryImageExist">
            <img :src="practiceAvatar" />
        </template>
        <span v-else>
            <svg viewBox="0 0 100 100" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                <text
                    x="51%"
                    y="53%"
                    font-size="33"
                    font-weight="400"
                    alignment-baseline="middle"
                    dominant-baseline="middle"
                    text-anchor="middle"
                >
                    {{ initials }}
                </text>
            </svg>
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            size: { type: String, required: true },
            type: { type: String, default: 'primary' },
            ancillary: { type: Object, default: undefined },
        },

        computed: {
            avatarClass() {
                return {
                    avatar: true,
                    [`avatar--size-${this.size}`]: true,
                    [`avatar--type-initials--type-${this.type}`]: true,
                }
            },

            ancillaryImageExist() {
                return this.ancillary.image && this.ancillary.image['thumb-360']
            },

            initials() {
                return this.initialsFromAncillary()
            },

            practiceAvatar() {
                if (this.ancillary?.image) {
                    return this.ancillary?.image['thumb-360']
                }
                return null
            },
        },

        methods: {
            initialsFromAncillary() {
                if (!this.ancillary?.name) {
                    return
                }
                return this.ancillary?.name
                    .split(' ', 2)
                    .filter((s) => !!s)
                    .map((s) => s[0])
                    .join(' ')
            },
        },
    }
</script>
